import React from "react";

/**
 * Signature pink asterisk mark used throughout the site as a decorative
 * flourish (bottom-right of deck cards, host section, footer, etc.).
 * Renders as an SVG so it scales cleanly and can animate on hover.
 */
export function AsteriskMark({ size = 96, className = "", spin = true }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={`${className} ${spin ? "animate-[spin_18s_linear_infinite]" : ""}`}
      aria-hidden="true"
      fill="none"
    >
      {Array.from({ length: 8 }).map((_, i) => (
        <ellipse
          key={i}
          cx="50"
          cy="50"
          rx="4.5"
          ry="45"
          fill="currentColor"
          transform={`rotate(${(i * 180) / 8} 50 50)`}
        />
      ))}
      <circle cx="50" cy="50" r="6" fill="currentColor" />
    </svg>
  );
}
